<template>
    <main id="mainCtrl">
        <dialog-metro
            ref="metroDialog"
            :checked-options="clinic.metros"
            :metro-options="metroOptions"
            :city="clinic.city"
            @confirm="onConfirmMetros" />

        <dialog-clinic-types
            ref="clinicTypesDialog"
            v-model="clinic.types"
            :proprietary="clinic.proprietary"
            :type-options="typeOptions"/>

        <image-cropper
            ref="cropper"
            :img="clinic.img ? clinic.img : ''"
            type="clinics"
            @crop-upload-success="cropUploadSuccess"
            upload-url="/imageCropperNew/clinics"
        />

        <ValidationObserver ref="clinicForm">
            <form class="clinicForm" v-cloak>
                <div style="height: 100%; overflow-x: hidden;">
                    <fieldset :class="{loading: clinic.url ===''}" style="display:block;">
                        <legend>Общая информация о клинике</legend>
                        <div class="alert alert-warning" v-if="clinic.moderationNeeded" style="margin-bottom: 10px;">
                            Внимание! Изменения отправлены на проверку. После проверки менеджером обновлённая информация
                            появится на сайте.
                        </div>

                        <table class="grid">
                            <tbody>
                                <tr>
                                    <td width="700" valign="top" minwidth="700">
                                        <table class="grid">
                                            <tbody>
                                                <tr>
                                                    <td width="150" valign="top">
                                                        <drag-and-drop @fileDropped="openCropWithNewFile">
                                                            <div class="imageCropper">
                                                                <button type="button" v-show="clinic.img !== ''"
                                                                    class="resetBtn small redHover" tooltip="Удалить логотип"
                                                                    @click="imageCropperDelete">
                                                                    <i class="fas fa-trash-can"></i>
                                                                </button>
                                                                <img src=""
                                                                    :src="clinic.img ? storagePublicUrl + '/images/clinics/150x150/' + clinic.img : ''"
                                                                    width="150" height="150" @click="imageCropperOpen"
                                                                    style="cursor: pointer; background-image: url(/_assets/pic_clinic.svg);" />
                                                            </div>
                                                            <button class="button small" @click.prevent="openClinicPage" width="150"
                                                                v-tooltip="`${frontendUrl}/${clinic.city}/clinic/${clinic.url}`"
                                                                style="margin: 5px 0 !important;">
                                                                <i class="fa fa-link"></i>
                                                                Показать на сайте
                                                            </button>
                                                        </drag-and-drop>
                                                    </td>
                                                    <td valign="top">
                                                        <vee-textarea v-model="clinic.name" placeholder="Название клиники"
                                                            :v-beautify="'capitalize itemclean typograf'" rules="required"
                                                            taStyle="min-height: 127px;resize: none;font-size: 24px;font-weight: bold;" :readonly="isSupport === false"></vee-textarea>
                                                        <table class="grid">
                                                            <tbody>
                                                                <tr>
                                                                    <td width="50%">
                                                                        <label>Форма собственности</label>
                                                                        <v-select
                                                                            v-model="clinic.proprietary"
                                                                            :disabled="true"
                                                                            :options='[
                                                                            {
                                                                                text: "\u00a0",
                                                                                value: ""
                                                                            },
                                                                            {
                                                                                text: "Частная",
                                                                                value: "private"
                                                                            },
                                                                            {
                                                                                text: "Государственная",
                                                                                value: "municipal"
                                                                            },
                                                                        ]'
                                                                        ></v-select>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table class="grid">
                                            <tbody>
                                                <tr>
                                                    <td width="25%">
                                                        <label>Город</label>
                                                        <v-select
                                                            v-model="clinic.city"
                                                            :disabled="true"
                                                            :options='cityOptions.map(({ text, value }) => {
                                                                return {
                                                                    text,
                                                                    value
                                                                }
                                                            })'
                                                        ></v-select>
                                                    </td>
                                                    <td width="25%" v-if="getFilteredOptions(localityOptions)">
                                                        <label>Населенный пункт</label>
                                                        <v-select
                                                            @close="recalcLocalityHandler"
                                                            v-model="clinic.locality"
                                                            :disabled="true"
                                                            :options='[
                                                                {
                                                                    text: "\u00a0",
                                                                    value: ""
                                                                },

                                                                ...localityOptions.map(({text, value}) => {
                                                                    return {
                                                                        text,
                                                                        value
                                                                    }
                                                                })
                                                            ]'
                                                        ></v-select>
                                                    </td>
                                                    <td width="25%" v-if="getFilteredOptions(districtOptions)">
                                                        <label>Район</label>
                                                        <v-select
                                                            v-model="clinic.district"
                                                            placeholder="Район"
                                                            :disabled="true"
                                                            :options='[
                                                                {
                                                                    text: "\u00a0",
                                                                    value: ""
                                                                },

                                                                ...districtOptions.map(({text, value}) => {
                                                                    return {
                                                                        text,
                                                                        value
                                                                    }
                                                                })
                                                            ]'
                                                        ></v-select>
                                                    </td>
                                                    <td width="25%" v-if="getFilteredOptions(areaOptions)"
                                                        style="padding-left: 4px">
                                                        <label>Округ</label>
                                                        <v-select
                                                            v-model="clinic.area"
                                                            placeholder="Округ"
                                                            :disabled="true"
                                                            :options='[
                                                                {
                                                                    text: "\u00a0",
                                                                    value: ""
                                                                },

                                                                ...areaOptions.map(({text, value}) => {
                                                                    return {
                                                                        text,
                                                                        value
                                                                    }
                                                                })
                                                            ]'
                                                        ></v-select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table class="grid">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <vee-input @blur="recalcAddressHandler" v-model="clinic.address" rules="required" placeholder="Адрес" />
                                                    </td>
                                                    <td width="140">
                                                        <button type="button" :disabled="clinic.city === ''"
                                                            @click="showAddressOnMap" class="small" required
                                                            :invalid="!clinic.markLat" style="position: relative; top: -3px;"
                                                            v-tooltip="`${(+clinic.markLat).toFixed(6)}, ${(+clinic.markLong).toFixed(6)}`">
                                                            <i class="fad fa-map-location-dot"></i>
                                                            Показать на карте
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div v-if="getFilteredOptions(metroOptions)">
                                            <label>Метро</label>
                                            <div class="textarea" @click="editMetros">
                                                <span class="comma">
                                                    <span v-for="(metro, index) in clinic.metros" :key="index">{{ metroOptions.find(metroOption => metroOption.value === metro).text }}</span>
                                                </span>
                                                <button class="tiny">Выбрать метро</button>
                                            </div>
                                        </div>

                                        <label>Категории</label>
                                        <ValidationProvider rules="required|clinicTypes" v-slot="{ errors }">
                                            <div class="textarea" :class="{ 'hasError': errors[0]}" v-model="clinic.types"
                                                v-tooltip="{
                                                content: errors[0],
                                                template: $errTemplate,
                                                }"
                                                @click.prevent.stop="editTypes">
                                                <span class="comma">
                                                    <span v-for="type in clinic.types">{{ typeOptions.find(item => item.value === type).text }}</span>
                                                </span>
                                                <button type="button" class="tiny">Выбрать</button>
                                            </div>
                                        </ValidationProvider>
                                    </td>

                                    <td style="vertical-align: top;">
                                        <div id="Ymap" style="width: 100%; height: 350px; background-color: #D0CFCF;"></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <hr style="margin: 5px 0 5px 0" />
                        <table class="grid">
                            <tr>
                                <td valign="top" width="70%">
                                    <label>Страница ДОКТУ</label>
                                    <div class="input text-ellipsis">
                                        <a :href="frontendUrl+'/'+(clinic.city === '' ? '—' : clinic.city)+'/clinic/'+clinic.url"
                                            target="_blank"
                                            class="text-ellipsis"
                                        >
                                            {{ frontendUrl.replace("https://", "") }}/{{
                                                clinic.city === '' ? '—' : clinic.city
                                            }}/clinic/{{ clinic.url }}
                                        </a>
                                    </div>
                                  <table class="grid">
                                    <tbody>
                                    <tr>
                                      <td colspan="4">
                                        <label>Официальное название</label>
                                        <input v-model="clinic.nameOfficial" v-beautify.literal="officialNameRule">
                                      </td>
                                      <td style="width: 20%">
                                        <label>Год основания</label>
                                        <input min="1800" :max="new Date().getFullYear()" v-model="clinic.estYear" type="number"
                                               units="г">
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="3">
                                        <label>ФИО главного врача</label>
                                        <input v-model="clinic.chiefDoctor">
                                      </td>
                                      <td style="width: 20%">
                                        <label>Прием по страховке</label>
                                        <v-select
                                            v-model="clinic.insuranceType"
                                            :options="insuranceTypes"
                                        ></v-select>
                                      </td>
                                      <td style="width: 20%">
                                        <label>Номер лицензии</label>
                                        <input v-model="clinic.licenceNum" v-beautify.literal="licenseNumber">
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td width="250" style="display: flex; flex-direction: column;margin-top: -5px;">
                                    <label style="margin-left: 25px;">Режим работы</label>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">пн</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.monFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.monTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.monFrom)"
                                            :options="timeOptionsMon"
                                        ></v-select>
                                    </div>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">вт</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.tueFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.tueTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.tueFrom)"
                                            :options="timeOptionsTue"
                                        ></v-select>
                                    </div>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">ср</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.wedFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.wedTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.wedFrom)"
                                            :options="timeOptionsWed"
                                        ></v-select>
                                    </div>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">чт</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.thuFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.thuTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.thuFrom)"
                                            :options="timeOptionsThu"
                                        ></v-select>
                                    </div>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">пт</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.friFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.friTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.friFrom)"
                                            :options="timeOptionsFri"
                                        ></v-select>
                                    </div>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">сб</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.satFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.satTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.satFrom)"
                                            :options="timeOptionsSat"
                                        ></v-select>
                                    </div>

                                    <div>
                                        <span style="width: 20px; display: inline-block;">вс</span>

                                        <v-select
                                            style="width: 100px; display: inline-block;"
                                            v-model="clinic.workTime.sunFrom"
                                            :options="timeOptionsFull"
                                        ></v-select>

                                        <v-select
                                            v-model="clinic.workTime.sunTill"
                                            style="width: 100px; display: inline-block;"
                                            :disabled="['', 'off', '24h'].includes(clinic.workTime.sunFrom)"
                                            :options="timeOptionsSun"
                                        ></v-select>
                                    </div>
                                </td>
                                <td valign="top" width="250">
                                    <div>
                                        <label>
                                            <input type="checkbox" v-model="clinic.hasTerminal"/>
                                            <span>Есть оплата картой</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" v-model="clinic.hasLaboratory"/>
                                            <span>Есть лаборатория</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" v-model="clinic.hasParking"/>
                                            <span>Есть парковка</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" v-model="clinic.hasHospital"/>
                                            <span>Есть стационар</span>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        </table>


                        <hr style="margin: 5px 0 5px 0" />

                        <label>Описание</label>
                        <v-quill ref="quill" v-model="clinic.description" :config="{eventsOnBlur: true}"/>

                        <label>Фотографии клиники</label>

                        <photo-gallery
                            id="photos"
                            v-model="clinic.photos"
                            :imagesBasePath="storagePublicUrl + '/images/clinicPhotos/120x120/'"
                            uploadUrl="/clinics/clinic/uploadPhoto"
                            buttonText="Добавить<br>фотографии<br>клиники"
                            @file-uploaded="photosUploaded"
                        ></photo-gallery>

                        <hr style="margin: 5px 0 5px 0" />

                        <label>Лицензии клиники</label>

                        <photo-gallery
                            id="licenses"
                            v-model="clinic.licences"
                            :imagesBasePath="storagePublicUrl + '/images/clinicLicences/Wx120/'"
                            uploadUrl="clinic/uploadLicence"
                            buttonText="Добавить<br>лицензии"
                            @file-uploaded="licenseUploaded"
                        ></photo-gallery>
                    </fieldset>
                </div>
            </form>
        </ValidationObserver>
        <footer style="margin-top: 5px" v-if="!(isSupport && clinic.moderationNeeded)">
            <v-loading-component @click="onUpdate">
                <template slot-scope="{ loadingClass }">
                    <button :disabled="!needSave" :class="[{green: needSave}, loadingClass]">Сохранить</button>
                </template>
            </v-loading-component>
        </footer>
    </main>
</template>

<script>

import imageCropper from '@base/ImageCropper';
import yMapsMixin from '@mixins/YMaps';
import DialogMetro from "@dialogs/common/clinics/MetroDialog";
import DialogClinicTypes from "@dialogs/common/clinics/ClinicTypesDialog";
import Draggable from 'vuedraggable';
import PhotoGallery from "@common/PhotoGallery";
import dragAndDrop from '@base/DragAndDrop.vue';
import { INSURANCE_TYPES, TIME_OPTIONS, TIME_OPTIONS_FULL, TIME_OPTIONS_WORK } from "@/global/const";

export default {
    components: {
        dragAndDrop,
        imageCropper,
        DialogMetro,
        DialogClinicTypes,
        Draggable,
        PhotoGallery
    },
    mixins: [yMapsMixin],
    props: {
        typeOptions: {
            type: Array,
            required: true
        },
        metroOptions: {
            type: Array,
            required: true
        },
        districtOptions: {
            type: Array,
            required: true
        },
        localityOptions: {
            type: Array,
            required: true
        },
        areaOptions: {
            type: Array,
            required: true
        },
        cityOptions: {
            type: Array,
            required: true
        },
        isSupport: {
            type: Boolean,
            required: true
        },
        storagePublicUrl: {
            type: String,
            required: true
        },
        frontendUrl: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            buffClinicAddress: '',
            buffClinicLocality: '',
            clinic: {
                id: '',
                moderationNeeded: false,
                address: '',
                area: '',
                city: 'spb',
                description: '',
                district: '',
                locality: '',
                img: '',
                imgOriginalPath: '',
                mapZoom: 16,
                markLat: '',
                markLong: '',
                metros: [],
                hasActiveSubscription: false,
                name: '',
                photos: [],
                types: [],
                proprietary: '',
                url: '',
                workTime: {
                    monFrom: '',
                    monTill: '',
                    tueFrom: '',
                    tueTill: '',
                    wedFrom: '',
                    wedTill: '',
                    thuFrom: '',
                    thuTill: '',
                    friFrom: '',
                    friTill: '',
                    satFrom: '',
                    satTill: '',
                    sunFrom: '',
                    sunTill: '',
                },
                nameOfficial: '',
                licenceNum: '',
                registryPhone: '',
                chiefDoctor: '',
                estYear: '',
                insuranceType: '',
                hasTerminal: 0,
                hasHospital: 0,
                hasLaboratory: 0,
                hasParking: 0,
                website: '',
                licences: [],
            },
            timeOptionsMon: TIME_OPTIONS,
            timeOptionsTue: TIME_OPTIONS,
            timeOptionsWed: TIME_OPTIONS,
            timeOptionsThu: TIME_OPTIONS,
            timeOptionsFri: TIME_OPTIONS,
            timeOptionsSat: TIME_OPTIONS,
            timeOptionsSun: TIME_OPTIONS,
            insuranceTypes: INSURANCE_TYPES,
            timeOptionsWork: TIME_OPTIONS_WORK,
            timeOptionsFull: TIME_OPTIONS_FULL,
            Mhashcode: null,
            cropperSettings: {
                show: false,
                params: {
                    name: null,
                    data: null,
                    imageWidth: null,
                    imageHeight: null,
                    width: null,
                    height: null,
                    left: null,
                    top: null
                }
            },
            galleryOptions: {
                index: null
            },
            galleryLicensesOptions: {
                index: null
            },
            doctuPhoneError: null,
            calltouchPhoneError: null,
        };
    },
    created: function () {
        ymaps.ready(() => {
            this.initMap();
            this.read();
        });
    },

    methods: {
        recalcMapModal(buffField, originField) {
            if (this[buffField]) {
                if (this[buffField] !== this.clinic[originField]) {
                    return () => this.$modal('Пересчитать координаты?',
                        {
                            name: 'Пересчитать',
                            callback: () => {
                                this[buffField] = this.clinic[originField];
                                this.showAddressOnMap();
                            }
                        },
                        {
                            name: 'Не пересчитывать',
                            callback: () => {
                                this[buffField] = this.clinic[originField];
                            }
                        }
                    )
                }
            } else {
                return () => {
                    this[buffField] = this.clinic[originField];
                }
            }
        },

        recalcAddressHandler() {
            this.recalcMapModal('buffClinicAddress', 'address');
        },

        recalcLocalityHandler() {
            this.recalcMapModal('buffClinicLocality', 'locality');
        },

        onUpdate(btn) {
            this.$refs.clinicForm.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }
                if (this.needSave) {
                    btn.startLoadingAnimation();

                    if (this.$refs.quill.inProcess) {
                        this.$refs.quill.quillEditor.setSelection(null)
                        setTimeout(() => {
                            this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                        }, 450)
                    }else{
                        this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                    }
                }
            });
        },
        openCropWithNewFile: function (file) {
            this.$refs.cropper.preloadFile(file);
            this.$refs.cropper.showModal();
        },
        photosUploaded: function (uploadedImageUrls, position) {
          uploadedImageUrls.reverse().forEach((url) => {
            this.clinic.photos.splice(position, 0, url)
          })
        },
        licenseUploaded(uploadedImageUrls, position) {
          uploadedImageUrls.reverse().forEach((url) => {
            this.clinic.licences.splice(position, 0, url)
          })
        },
        cropUploadSuccess: function (imageUrl, field) {
            this.clinic.img = imageUrl;
        },

        read: function () {
            return this.axios.post('clinic/read').then(response => {
                this.clinic = response.data;
                this.updateMap(this.clinic.markLat, this.clinic.markLong, this.clinic.mapZoom);
                this.buffClinicLocality = this.clinic.locality;
                this.buffClinicAddress = this.clinic.address;

                setTimeout(() => {
                    this.Mhashcode = JSON.stringify(this.clinic).hashCode();
                }, 500)
            });
        },

        update: function (e) {
            return this.axios.post('clinic/update/'+this.clinic.id, this.clinic).then(() => {
                this.read().then(() => {
                    if (this.clinic.moderationNeeded) {
                        this.$modal('Данные отправлены на проверку', {
                            name: 'ОК',
                            callback: () => {}
                        }, {}, false)
                    }
                });
            });
        },

        openClinicPage: function () {
            window.open('http://doctu.ru/' + this.clinic.city + '/clinic/' + this.clinic.url, '_blank');
        },

        coordsToModel: function () {
            this.$nextTick(() => {
                let coords = this.mapSettings.clinicsPlacemark.geometry.getCoordinates();

                if (coords) {
                    this.clinic.markLong = coords[1];
                    this.clinic.markLat = coords[0];
                }
                this.clinic.mapZoom = this.mapSettings.clinicsMap.getZoom();
            });
        },
        showAddressOnMap: function (e) {
            this.axios.post('/getCoordsByAddress', {
                city: this.clinic.city,
                locality: this.clinic.locality,
                address: this.clinic.address
            }).then(response => {
                const data = response.data;

                this.clinic.markLat = data.geoLat;
                this.clinic.markLong = data.geoLong;
                this.clinic.mapZoom = 16;

                this.updateMap(this.clinic.markLat, this.clinic.markLong, this.clinic.mapZoom);

                let oldDistrictName = (this.districtOptions.find(option => {
                        return option.value === this.clinic.district && option.city === this.clinic.city
                    }
                ) || {}).text || '[НЕ ЗАДАН]';
                let newDistrictName = (this.districtOptions.find(option => {
                    return option.value === data.district && option.city === this.clinic.city
                }) || {}).text || '[НЕ ЗАДАН]';

                if (oldDistrictName !== newDistrictName) {
                    if (oldDistrictName === '[НЕ ЗАДАН]') {
                        this.clinic.district = data.district;

                    } else {
                        this.$modal(`Заменить район <br><b> ${oldDistrictName} </b> на <b>${newDistrictName}</b>?`,
                            {
                                name: "Заменить",
                                callback: () => {
                                    this.clinic.district = data.district;
                                }
                            },
                            {
                                name: "Нет"
                            }
                        );
                    }
                }

                let oldLocalityName = (this.localityOptions.find(option => {
                    return option.value === this.clinic.locality && option.city === this.clinic.city
                }) || {}).text || '[НЕ ЗАДАН]';
                let newLocalityName = (this.localityOptions.find(option => {
                    return option.value === data.locality && option.city === this.clinic.city
                }) || {}).text || '[НЕ ЗАДАН]';

                if (oldLocalityName !== newLocalityName) {
                    if (oldLocalityName === '[НЕ ЗАДАН]') {
                        this.clinic.locality = data.locality;
                    } else {
                        this.$modal(`Заменить населенный пункт <br><b>${oldLocalityName}</b> на <b>${newLocalityName}</b>?`,
                            {
                                name: "Заменить",
                                callback: () => {
                                    this.clinic.locality = data.locality;
                                }
                            },
                            {
                                name: "Нет"
                            }
                        );
                    }
                }

                let oldAreaName = (this.areaOptions.find(option => {
                    return option.value === this.clinic.area && option.city === this.clinic.city
                }) || {}).text || '[НЕ ЗАДАН]';
                let newAreaName = (this.areaOptions.find(option => {
                    return option.value === data.area && option.city === this.clinic.city
                }) || {}).text || '[НЕ ЗАДАН]';
                if (oldAreaName !== newAreaName) {
                    if (oldAreaName === '[НЕ ЗАДАН]') {
                        this.clinic.area = data.area;

                    } else {
                        this.$modal(`Заменить округ <br><b>${oldAreaName}</b> на <b>${newAreaName}</b>?`,
                            {
                                name: "Заменить",
                                callback: () => {
                                    this.clinic.area = data.area;
                                }
                            },
                            {
                                name: "Нет"
                            }
                        );
                    }
                }

                const mapMetroName = (el) => {
                    return (this.clinic.metroOptions.find(option => option.value === el) || {}).text || '[НЕ ЗАДАН]';
                };

                let oldMetroNames = this.clinic.metros.map(mapMetroName).join(', ');
                let newMetroNames = data.metros.map(mapMetroName).join(', ');
                if (oldMetroNames !== newMetroNames) {
                    if ((oldMetroNames === '[НЕ ЗАДАН]') || (oldMetroNames === '')) {
                        this.clinic.metros = data.metros;
                    } else {
                        this.$modal(`Заменить метро <br><b>${oldMetroNames}</b><br> на <br><b>${newMetroNames}</b>?`,
                            {
                                name: "Заменить",
                                callback: () => {
                                    this.clinic.metros = data.metros;
                                }
                            },
                            {
                                name: "Нет"
                            }
                        );
                    }
                }
            });
        },

        editTypes: function (event) {
            event.preventDefault();
            this.$refs.clinicTypesDialog.$refs.dialog.show();
        },

        editMetros: function (event) {
            event.preventDefault();
            this.$refs.metroDialog.$refs.dialog.show();
        },

        onConfirmMetros: function (checkedOptions) {
            this.clinic.metros = checkedOptions;
            this.$refs.metroDialog.$refs.dialog.hide();
        },
        imageCropperDelete: function (event) {
            this.$modal("Удалить логотип?", {
                    name: 'Удалить',
                    callback: () => {
                        this.clinic.img = '';
                    }
                },
                {
                    name: 'Нет'
                }
            );
        },

        imageCropperOpen: function () {
            if (this.clinic.img === '') {
                this.$refs.cropper.showFileChooser();
            } else {
                this.$refs.cropper.showModal();
            }
        },

        removePhoto: function (index) {
            this.clinic.photos.splice(index, 1);
        },

        removeLicence: function (index) {
            this.clinic.licences.splice(index, 1);
        },

        getFilteredOptions: function (options) {
            return options.find(option => option.city === this.clinic.city);
        },
    },
    watch: {
        needSave(val){
            if (val){
                window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
            }else{
                window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
            }
        },
        'clinic.workTime.monFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.monTill = '';
            } else {
                this.timeOptionsMon = TIME_OPTIONS;
            }
        },
        'clinic.workTime.tueFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.tueTill = '';
            } else {
                this.timeOptionsTue = TIME_OPTIONS;
            }
        },
        'clinic.workTime.wedFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.wedTill = '';
            } else {
                this.timeOptionsWed = TIME_OPTIONS;
            }
        },
        'clinic.workTime.thuFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.thuTill = '';
            } else {
                this.timeOptionsThu = TIME_OPTIONS;
            }
        },
        'clinic.workTime.friFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.friTill = '';
            } else {
                this.timeOptionsFri = TIME_OPTIONS;
            }
        },
        'clinic.workTime.satFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.satTill = '';
            } else {
                this.timeOptionsSat = TIME_OPTIONS;
            }
        },
        'clinic.workTime.sunFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.clinic.workTime.sunTill = '';
            } else {
                this.timeOptionsSun = TIME_OPTIONS;
            }
        },
    },
    computed: {
        needSave: function () {
            return this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.clinic).hashCode());
        },

        officialNameRule: function () {
            return "capitalize itemclean striptags typograf";
        },

        licenseNumber: function () {
            return "itemclean striptags typograf";
        },

        headers: function () {
            const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

            return {
                'X-CSRF-TOKEN': csrfToken
            };
        }
    }
}
</script>

<style lang="scss">
main#mainCtrl {
    .five-elem {
        width: 20%
    }

    .ymaps {
        width: 100%;
        height: 350px;
        background-color: #D0CFCF;
    }

    #uploadedPhotos, #uploadedLicences {
        .thumb {
            overflow: hidden;
            display: inline-block;
            position: relative;
            margin: 0 10px 5px 0;

            button {
                position: absolute;
                top: 0;
                right: 0;
            }
        }

        .ajax-file-upload-placeholder {
            display: inline-block;
            position: relative;
            margin: 0 10px 5px 0;
        }

    }

    #uploadedPhotos {
        .ajax-file-upload {
            width: 120px;
            height: 120px;

            input[type=file] {
                width: 120px !important;
                height: 120px !important;
            }

            &.button {
                padding-top: 27px;
            }
        }

        .ajax-file-upload-placeholder {
            width: 120px !important;
            height: 120px !important;
        }
    }

    #uploadedLicences {
        .ajax-file-upload {
            width: 120px;
            height: 120px;

            input[type=file] {
                width: 120px !important;
                height: 120px !important;
            }

            &.button {
                padding-top: 37px;
            }
        }

        .ajax-file-upload-placeholder {
            width: 84px !important;
            height: 120px !important;
        }
    }
}

.multiselect {
    font-size: 16px !important;

    &__single {
        line-height: 21px !important;
        font-size: 16px !important;
    }

    &__input {
        font-size: 16px !important;
    }

    &__placeholder {
        font-size: 16px !important;
        color: #ccc !important;
        text-overflow: ellipsis;
        padding-left: 1px;
    }

    &--disabled {
        .multiselect__single {
            color: #ccc !important;
            line-height: 21px !important;
        }
    }
}
.clinicForm {
  height: calc(100vh - 130px); overflow-x: hidden;
}
.wrapper.withTopBanner .clinicForm {
  height: calc(100vh - 180px);
}
</style>
